import { OI_ALL_GRAPH, OI_CHANGE_GRAPH, OI_CHART_GRAPH, OPTION_CHAIN_GRAPH_ERROR, OPTION_CHAIN_GRAPH_EXPIRY_DATE_DATA, OPTION_CHAIN_GRPAH_HIDE_ERROR, OPTION_CHAIN_GRPAH_START_LOADER, OPTION_CHAIN_GRPAH_STOP_LOADER, OPTION_PAIN_GRAPH, } from "../interface/iOptionChainGraphs";
const initialState = {
    data: {},
    OIChartLoader: false,
    OIChangeLoader: false,
    OptionPainLoader: false,
    OptionMainLoader: false,
    OIChartErrorData: {
        error: null,
        isOpen: null,
    },
    OIChangeErrorData: {
        error: null,
        isOpen: null,
    },
    OptionPainErrorData: {
        error: null,
        isOpen: null,
    },
};
const optionChartGraphReducer = (state = initialState, action) => {
    switch (action.type) {
        case OI_ALL_GRAPH:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case OI_CHART_GRAPH:
            state.data.OIChart = action.payload.data.OIChart;
            return Object.assign({}, state);
        case OI_CHANGE_GRAPH:
            state.data.OIChange = action.payload.data.OIChange;
            return Object.assign({}, state);
        case OPTION_PAIN_GRAPH:
            state.data.OptionPain = action.payload.data.OptionPain;
            return Object.assign({}, state);
        case OPTION_CHAIN_GRAPH_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case OPTION_CHAIN_GRPAH_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initialState[action.errorType] });
        case OPTION_CHAIN_GRPAH_START_LOADER:
            return Object.assign(Object.assign({}, state), { [action.loaderType]: true });
        case OPTION_CHAIN_GRAPH_EXPIRY_DATE_DATA:
            return Object.assign(Object.assign({}, state), { expiryDateList: action.payload.expiryDateList });
        case OPTION_CHAIN_GRPAH_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { [action.loaderType]: initialState[action.loaderType] });
        default:
            return Object.assign({}, state);
    }
};
export default optionChartGraphReducer;
